const language = [
  ['钱包登录','錢包登錄', 'Wallet Login'],
  ['总收益(USDT)','總收益(USDT)', 'Total Revenue(USDT)'],
  ['可提取','可提取', 'Extractable'],
  ['提取收益','提取收益', 'Withdrawable'],
  ['钱包资产','錢包資產', 'Wallet'],
  ['托管本金','託管本金', 'Custody'],
  ['参与托管','參與託管', 'Participate'],
  ['提取本金','提取本金', 'Withdraw'],
  ['邀请好友','邀請好友', 'Invite'],
  ['购买NFT','購買NFT', 'BuyNFT'],
  ['月化收益','月化收益', 'Monthly Income'],
  ['收益实时结算 参与即收益','收益實時結算 參與即收益', 'Revenue Real-time settlement participation is revenue'],
  ['资产列表','資產列表', 'Asset list'],
  ['租赁限额10-5000','租賃限額10-5000', 'The Custody Limit Is 10-5000'],
  ['预计月化收益','預計月化收益', 'Estimated Monthly Income'],
  ['开始托管','開始託管', 'Start Hosting'],
  ['托管数额需大于零','託管數額需大於零', 'The amount of hosting should > zero'],
  ['余额不足','餘額不足', 'Insufficient balance'],
  ['请输入托管金额','請輸入託管金額', 'Please enter the custody amount'],
  ['托管成功','託管成功', 'success '],
  ['价格','價格', 'Price '],
  ['已售','已售', 'Sold '],
  ['剩余','剩餘', 'Remaining '],
  ['购买','購買', 'Buy '],
  ['购买数量','購買數量', 'Num '],
  ['请输入购买数量','請輸入購買數量', 'Please enter the purchase num '],
  ['待支付','待支付', 'Total '],
  ['托管列表','託管列表', 'Hosted List '],
  ['全部','全部', 'All '],
  ['托管中','託管中', 'Hosted '],
  ['已结束','已結束', 'Over '],
  ['托管金额','託管金額', 'Escrow amount '],
  ['时间','時間', 'Time '],
  ['当前收益','當前收益', 'Current Earnings '],
  ['社区','社區', 'Community '],
  ['暂无信息准备中','暫無信息準備中', 'No information is being prepared '],
  ['推荐收益','推薦收益', 'Referral Income'],
  ['你的团队','你的團隊', 'Your Team'],
  ['查看更多','查看更多', 'See More'],
  ['团队交易','團隊交易', 'Team Deal'],
  ['选择提取类型','選擇提取類型', 'Select Extraction Type'],
  ['立即分享给好友','立即分享給好友', 'Share With Friends Now'],
  ['复制成功','複製成功', 'Copy Successfully'],
  ['个人中心','個人中心', 'Personal Center'],
  ['总资产','總資產', 'Total Assets'],
  ['提取资产','提取資產', 'Withdraw Assets'],
  ['关注我们','關注我們', 'Follow Us'],
  ['社区资料','社區資料', 'Community Profile'],
  ['关于我们','關於我們', 'About Us'],
  ['选择语言','選擇語言', 'Language'],
  ['托管收益','託管收益', 'Managed Income'],
  ['切换语言','切換語言', 'Switch Language'],
  ['交易记录','交易記錄', 'Transaction Record'],
  ['托管','託管', 'Hosting'],
  ['提取','提取', 'Extract'],
  ['数量','數量', 'Amount'],
  ['交易ID','交易ID', 'Transaction ID'],
  ['状态','狀態', 'State'],
  ['成功','成功', 'Success'],
  ['失败','失敗', 'Fail'],
  ['类型','類型', 'Type'],
  ['已量化30天','已量化30天', 'Quantified for 30 days'],
  ['提取数量','提取數量', 'Withdrawal Amount'],
  ['全部提取','全部提取', 'Extract All'],
  ['手续费','手續費', 'Handling Fee'],
  ['接收地址','接收地址', 'Receiving Address'],
  ['确定提取','確定提取', 'OK to Extract'],
  ['注意','注意', 'Notice'],
  ['该笔本金托管不足6个月，提取将收取20%的基金管理费 6个月之后提取将不在收取任何基金管理费','該筆本金託管不足6個月，提取將收取20%的基金管理費 6個月之後提取將不在收取任何基金管理費', 'If the principal is quantified for less than 6 months, a 20% fund management fee will be charged for the withdrawal. After 6 months, no fund management fee will be charged for the withdrawal.'],
  ['取消','取消', 'Cancel'],
  ['提取数额不能为空','提取數額不能為空', 'Withdrawal amount cannot be empty'],
  ['接收地址不能为空','接收地址不能為空', 'Receiving address cannot be empty'],
  ['提取成功','提取成功', 'Success'],
  ['收益','收益', 'Income'],
  ['可提取收益','可提取收益', 'Withdrawable income'],
  ['提醒：提取托管收益时，75%的收益将转入接收地址，25%将用于购买CD进行销毁并转换成等值算力，获得CD！','提醒：提取託管收益時，75%的收益將轉入接收地址，25%將用於購買CD進行銷毀並轉換成等值算力，獲得CD！', 'Reminder: When withdrawing custody income, 75% of the income will be transferred to the receiving address, and 25% will be used to purchase CD for destruction and conversion into equivalent computing power to obtain CD!'],
  ['简介','簡介', 'Introduction'],
  ['团队成员来自全球多个国家和地区，有密码学专家、区块链资深从业者以及AI人工智能等方面的高科技技术人才，同时还有专注一级市场投研的加密人士和传统金融行业资产管理专家。','團隊成員來自全球多個國家和地區，有密碼學專家、區塊鏈資深從業者以及AI人工智能等方面的高科技技術人才，同時還有專註一級市場投研的加密人士和傳統金融行業資產管理專家。', 'The team members come from many countries and regions around the world. There are cryptography experts, senior blockchain practitioners, and high-tech talents in AI and artificial intelligence. At the same time, there are encryption professionals who focus on primary market investment research and traditional financial industry assets. management experts.'],
  ['社区主要专注于早期优质区块链项目的节点搭建服务和AI抓取链上数据进行量化套利。服务过的项目包括:ENS、Dydx、OP、Gal  和APT等，均获得10倍以上的回报！ 技术团队发挥自身优势，建立开放透明的加密投资环境，帮助更多DAO成员在加密市场共获财富！','社區主要專注於早期優質區塊鏈項目的節點搭建服務和AI抓取鏈上數據進行量化套利。服務過的項目包括:ENS、Dydx、OP、Gal  和APT等，均獲得10倍以上的回報！技術團隊發揮自身優勢，建立開放透明的加密投資環境，幫助更多DAO成員在加密市場共獲財富！', 'The community mainly focuses on node building services for early high-quality blockchain projects and AI captures data on the chain for quantitative arbitrage. The projects I have served include: ENS, Dydx, OP, Gal and APT, etc., all of which have received more than 10 times the return! The technical team gives full play to its own advantages, establishes an open and transparent encryption investment environment, and helps more DAO members gain wealth in the encryption market!'],
  ['算力收益','算力收益', 'Hashrate Income'],
  ['没有收益可以提取','沒有收益可以提取', 'No income can be withdrawn'],
  ['需要先提取收益','需要先提取收益', 'Need to extract the income first'],
  ['只能托管10的倍数','只能託管10的倍數', 'Only multiple of 10 can be managed'],
  ['总托管量不能超过5000','總託管量不能超過5000', 'Total hosting capacity cannot exceed 5000'],
  ['暂无数据','暫無數據', 'No Data'],
  ['托管收益','託管收益', 'Custody income'],
  ['推荐收益','推薦收益', 'Referral Income'],
  ['购买成功','購買成功', 'successful purchase'],
  ['总托管金额不能超过5000','總託管金額不能超過5000', 'The total custody amount cannot exceed 5000'],
  ['暂时无法交易','暫時無法交易', 'Temporarily unavailable'],
  ['CD收益','CD收益', 'CD income'],
  ['每日收益','每日收益', 'Daily Income'],
  ['查看CD价格走势','查看CD價格走勢', 'View CD price trend'],
  ['算力','算力', 'Hashrate'],
  ['今日购买','今日購買', 'Buy Today'],
  ['已释放','已釋放', 'Released'],
  ['天','天', 'days'],
  ['开始时间','開始時間', 'startTime'],
  ['先回本 利润五五分','先回本 利潤五五分', 'A 50-50 rebate on the profits'],
  ['全权托管 专项托管自由选择 项目上线 收益分配','全權托管 專項托管自由選擇 項目上線 收益分配', 'Discretionary trusteeship Special trusteeship free choice project online income distribution'],
  ['参与传统托管','參與傳統托管', 'Trusteeship'],
  ['需输入3000的倍数','需輸入3000的倍數', 'Enter a multiple of 3000'],
  ['选择托管账号','選擇托管賬號', 'Select hosting account'],
  ['传统托管记录','傳統托管記錄', 'Traditional custody record'],
  ['全权托管','全權托管', 'Discretionary Trust'],
  ['专项托管','專項托管', 'Special Trusteeship'],
  ['本金','本金', 'Capital'],
  ['自动根据下面选择计算','自動根據下面選擇計算', 'Automatically calculate according to the selection below'],
  ['号','號','Number'],
  ['确定','確定','Success'],
  ['托管协议','托管協議','Escrow Agreement'],
  ['下载托管协议','下載托管協議','Download Escrow Agreement'],
  ['租赁本金','租賃本金', 'Custody'],
  ['设备租赁','設備租賃', 'Lease'],
  ['贡献列表','貢獻列表', 'Contribution'],
  ['进行租赁','進行租賃', 'Lease'],
  ['贡献值','貢獻值', 'Contribution Value'],
  ['提取收益15%用于投研,提取收益15%用于铸币','提取收益15%用于投研,提取收益15%用于鑄幣', '15% of the withdrawal income is used for investment research, and 15% of the withdrawal income is used for coinage'],
  ['铸币释放','鑄幣釋放','Mintage Release'],
  ['质押释放','質押釋放','Pledge Release'],
  ['铸币','鑄幣','Mintage'],
  ['铸币贡献值','鑄幣貢獻值','Coinage Contribution'],
  ['投研贡献值','投研貢獻值','Investment Research Contribution'],
  ['锁定中','鎖定中','Locked'],
  ['提币','提幣','Withdraw'],
  ['质押解锁','質押解鎖','Unlocking'],
  ['租赁后本金不可取出，收益金额超出本金的规定倍数，部分将进行锁定，再次进行租赁可解锁收益','租賃後本金不可取出，收益金額超出本金的規定倍數，部分將進行鎖定，再次進行租賃可解鎖收益','After leasing, the principal cannot be withdrawn, and the income amount exceeds the specified multiple of the principal, part of it will be locked, and the income can be unlocked by leasing again'],
  ['租赁收益','租賃收益','Lease Income'],
  ['租赁列表','租賃列表','Lease List'],
  ['租赁金额','租賃金額','Lease Amount'],
  ['收益中','收益中','Income'],
  ['已结束','已结束','Finished'],
  ['租赁','租賃', 'Lease'],
  ['提醒：用户提取收益的10%将进行矿机购买','提醒：用戶提取收益的10%將進行礦機購買', 'Reminder: 10% of the user\'s withdrawal proceeds will be made for mining machine purchases'],
  ['提取额度已用完,请再次租赁','提取額度已用完,請再次租賃', 'The withdrawal limit has been used up, please lease again'],
  ['铸币数量','鑄幣數量', 'Coinage'],
  ['可铸币','可鑄幣', 'Mintable Coins'],
  ['确定铸币','確定鑄幣', 'Coinage'],
  ['提醒:总量的30%铸币结束后，每月20%进行释放！','提醒:總量的30%鑄幣結束後，每月20%進行釋放！', 'Reminder: 30% of the total amount of coins will be released every month after the completion of 20%!'],
  ['可提取收益额度已用完，剩余收益将锁定，若需要继续提取请再次租赁解锁','可提取收益額度已用完，剩余收益將鎖定，若需要繼續提取請再次租賃解鎖','The amount of withdrawable income has been used up, the remaining income will be locked, if you need to continue to withdraw, please lease again to unlock'],
  ['可领取','可領取','Claimable'],
  ['10U-1000U 2倍收益提取','10U-1000U 2倍收益提取','10U-1000U 2x income extraction'],
  ['1000U-3000U 2.2倍收益提取','100U-1000U 2倍收益提取','1000U-3000U 2.2 times revenue extraction'],
  ['3000U-5000U 2.5倍收益提取','100U-1000U 2倍收益提取','3000U-5000U 2.5 times revenue extraction'],
  ['用户提取收益时的10%将进行铸币','用戶提取收益時的10%將進行鑄幣','10% of the proceeds withdrawn by the user will be minted'],
  ['收益提取额度','收益提取額度','Income withdrawal limit'],
  ['剩余提取额度','剩余提取額度','Residual withdrawal limit'],
  ['首页','首頁','Home'],
  ['领取收益','領取收益','Withdraw Income'],
  ['转账','轉賬','Transfer'],
  ['领取CD','領取CD','Withdraw CD'],
  ['关于我们','關於我們','Abouts Us'],
  ['所有好友','所有好友','All Friends'],
  ['托管详情','托管詳情','Trusteeship Details'],
  ['ChatGPT','ChatGPT','ChatGPT'],
  ['释放未开启','釋放未開啟','Release not open'],
  ['收益列表','收益列表','Income List'],
  ['当日收益','當日收益', 'Daily Income '],
  ['确定绑定','確定綁定', 'Bind'],
  ['绑定','綁定', 'Bind'],
  ['上级地址','上級地址', 'Parent Address'],
  ['是否确认绑定?','是否確認綁定?', 'Do you confirm binding?'],
  ['上级地址不正确','上級地址不正確', 'The binding upper-level address is incorrect'],
  ['不能绑定自己','不能綁定自己', 'Cannot bind oneself'],
  ['已经绑定上级','已經綁定上級', 'Bound to the upper level'],
  ['不能绑定自己的下级','不能綁定自己的下級', 'Cannot bind their own subordinates'],
  ['提取不能低于10','提取不能低於10', 'Extraction cannot be less than 10'],
  ['铸币不能低于10','鑄幣不能低於10', 'The coin cannot be less than 10'],
  ['超出提取额度，请复投','超出提取額度，請復投', 'Exceed the withdrawal limit, please re-invest'],
  ['返回最上级','返回最上級', 'Back to top'],
  ['铸币贡献','鑄幣貢獻','Coinage Contribution'],
  ['投研贡献','投研貢獻','Investment Research Contribution'],
  ['提醒','提醒','Remind'],
  ['历史可提取','历史可提取', 'History Extractable'],
  ['超出提取额度，请复投,复投额度需要达成历史可提取的一半','超出提取額度，請復投,復投額度需要達成歷史可提取的一半', 'If you exceed the withdrawal limit, please re-invest, and the re-investment limit needs to reach half of the historical withdrawal'],
  ['历史总收益','历史总收益', 'History Total Extractable'],
];

export default language;
